import {
  createFrontendModule,
  createRouteRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { PageErrorBoundary } from '@vivicta/ui';

/**
 * Replaces `page:user-settings` from `@backstage/plugin-user-settings` with a
 * Tailwind/shadcn page (ADR-0012) that also exposes an explicit sign-out — the
 * stock page offers none, and the portal replaces Backstage's sidebar (which is
 * where the stock sign-out lives) with `VivictaSidebar`.
 *
 * Aliasing the plugin's own route ref keeps `useRouteRef` call sites and the
 * `page:user-settings` nav item pointing here. The stock `sub-page:*` tabs stay
 * attached to the `pages` input but are never rendered: `PageBlueprint` ignores
 * that input once `loader` is set.
 *
 * `noHeader` suppresses the `PluginHeader` bar the blueprint would otherwise
 * stack above the page's own branded `Header`.
 */
export const settingsModule = createFrontendModule({
  pluginId: 'user-settings',
  extensions: [
    PageBlueprint.make({
      params: {
        path: '/settings',
        noHeader: true,
        routeRef: createRouteRef({ aliasFor: 'user-settings.root' }),
        loader: () =>
          import('./VivictaSettingsPage').then(m => (
            <PageErrorBoundary title="Settings">
              <m.VivictaSettingsPage />
            </PageErrorBoundary>
          )),
      },
    }),
  ],
});
